module.exports = __webpack_public_path__ + "static/media/TRI.503c0a19.svg";